import { ActionCreator } from 'redux';
import { Log, DeliveryLogType, InProgressStats } from '@dev/ee-api/ee-api-models';
import { uniqueId } from 'lodash-es';
import {
    LoadLogsStartAction,
    LoadLogsSuccessAction,
    LoadLogsErrorAction,
    LoadInprogressStatsStartAction,
    LoadInprogressStatsSuccessAction,
    LoadInprogressStatsErrorAction,
    LoadInprogressStatsStartDelayedAction,
    LoadInprogressStatsSuccessDelayedAction,
    LoadInprogressStatsErrorDelayedAction,
    SetLoaderInprogressStatsAction,
    LoadCancelInprogressStartAction,
    LoadCancelInprogressSuccessAction,
    LoadCancelInprogressErrorAction,
    ExportLogsAction,
    ExportLogsStartAction,
    ExportLogsSuccessAction,
    ExportLogsErrorAction,
    StdLoadLogsInterface,
    LoadNotificationLogsAction,
    NotificationLogsTypes,
    LoadNotificationLogsSuccessAction,
    ResendStartAction,
    ResendSuccessAction,
    ResendErrorAction,
    LogsState,
    ClearLogListAction,
    UpdateEventsCountsSuccessAction,
    LogsActionTypesEnum,
    FetchEventsCountsPayload,
    FetchEventsCountsAction,
} from './types';
import { ExportLogsParams, ResendParams } from '@api/services/ElasticApi';
import { ApplicationState } from '..';

export const LoadLogsStart: ActionCreator<LoadLogsStartAction> = (params: StdLoadLogsInterface): LoadLogsStartAction => {
    return {
        type: '@@logs/LOAD_LOG_START',
        payload: {
            logLoading: true,
            ...params,
        },
    };
};
interface LoadLogsSuccessProps {
    logList: Log;
    inProgressLogPage: number;
    totalLogsCount: number;
    statusesInProgress?: DeliveryLogType[];
    hasMoreLogs?: boolean;
}

export const LoadLogsSuccess = ({
    logList,
    inProgressLogPage,
    totalLogsCount,
    statusesInProgress,
    hasMoreLogs,
}: LoadLogsSuccessProps): LoadLogsSuccessAction => {
    return {
        type: '@@logs/LOAD_LOG_SUCCESS',
        payload: {
            logList,
            inProgressLogPage,
            totalLogsCount,
            logLoading: false,
            statusesInProgress,
            hasMoreLogs,
        },
    };
};

export const LoadLogsError: ActionCreator<LoadLogsErrorAction> = (): LoadLogsErrorAction => {
    return {
        type: '@@logs/LOAD_LOG_ERROR',
        payload: {
            logLoading: false,
        },
    };
};

export const ClearLogList = (): ClearLogListAction => {
    return {
        type: '@@logs/CLEAR_LOG_LIST',
    };
};

export const LoadNotificationLogs: ActionCreator<LoadNotificationLogsAction> = (
    params: StdLoadLogsInterface
): LoadNotificationLogsAction => ({
    type: NotificationLogsTypes.LOAD,
    payload: {
        ...params,
        logLoading: true,
    },
});

export const LoadNotificationLogsSuccess = (
    notificationList: Log,
    inProgressLogPage?: number,
    totalLogsCount?: number,
    hasMoreLogs?: boolean
): LoadNotificationLogsSuccessAction => ({
    type: NotificationLogsTypes.SUCCESS,
    payload: {
        notificationList,
        inProgressLogPage,
        totalLogsCount,
        logLoading: false,
        hasMoreLogs,
    },
});

export const ExportLogs: ActionCreator<ExportLogsAction> = (params: ExportLogsParams): ExportLogsAction => ({
    type: '@@logs/EXPORT_LOG',
    payload: params,
});
export const ExportLogsStart: ActionCreator<ExportLogsStartAction> = (): ExportLogsStartAction => ({
    type: '@@logs/EXPORT_LOG_START',
});
export const ExportLogsSuccess: ActionCreator<ExportLogsSuccessAction> = (): ExportLogsSuccessAction => ({
    type: '@@logs/EXPORT_LOG_SUCCESS',
});
export const ExportLogsError: ActionCreator<ExportLogsErrorAction> = (): ExportLogsErrorAction => ({
    type: '@@logs/EXPORT_LOG_ERROR',
});

export const LoadInprogressStatsStart = (inProgressActivePage: number): LoadInprogressStatsStartAction => {
    return {
        type: '@@logs/LOAD_IN_PROGRESS_STATS_START',
        payload: {
            inProgressLoading: true,
            inProgressActivePage,
        },
    };
};
export const LoadInprogressStatsSuccess: ActionCreator<LoadInprogressStatsSuccessAction> = (
    inprogressStats: InProgressStats,
    inProgressActivePage: number
): LoadInprogressStatsSuccessAction => {
    return {
        type: '@@logs/LOAD_IN_PROGRESS_STATS_SUCCESS',
        payload: {
            inprogressStats,
            inProgressActivePage,
            inProgressLoading: false,
        },
    };
};
export const LoadInprogressStatsError: ActionCreator<LoadInprogressStatsErrorAction> = (): LoadInprogressStatsErrorAction => {
    return {
        type: '@@logs/LOAD_IN_PROGRESS_STATS_ERROR',
        payload: {
            inProgressLoading: false,
        },
    };
};

export const LoadInprogressStatsStartDelayed: ActionCreator<LoadInprogressStatsStartDelayedAction> = (
    inProgressActivePage
): LoadInprogressStatsStartDelayedAction => {
    return {
        type: '@@logs/LOAD_IN_PROGRESS_STATS_DELAYED_START',
        payload: {
            inProgressDelayedLoopId: uniqueId(),
            inProgressDelayedLoading: true,
            inProgressActivePage,
        },
    };
};
export const LoadInprogressStatsSuccessDelayed: ActionCreator<LoadInprogressStatsSuccessDelayedAction> = (
    inprogressStatsDelayed: InProgressStats,
    inProgressActivePage: number
): LoadInprogressStatsSuccessDelayedAction => {
    return {
        type: '@@logs/LOAD_IN_PROGRESS_STATS_DELAYED_SUCCESS',
        payload: {
            inprogressStatsDelayed,
            inProgressActivePage,
            inProgressDelayedLoading: false,
        },
    };
};
export const SetLoaderInprogressStats: ActionCreator<SetLoaderInprogressStatsAction> = (
    setLoader: boolean
): SetLoaderInprogressStatsAction => {
    return {
        type: '@@logs/SET_INPROGRESS_LOADER',
        payload: {
            setLoader,
        },
    };
};
export const LoadInprogressStatsErrorDelayed: ActionCreator<
    LoadInprogressStatsErrorDelayedAction
> = (): LoadInprogressStatsErrorDelayedAction => {
    return {
        type: '@@logs/LOAD_IN_PROGRESS_STATS_DELAYED_ERROR',
        payload: {
            inProgressDelayedLoading: false,
        },
    };
};

export const LoadCancelInprogressStart: ActionCreator<LoadCancelInprogressStartAction> = (): LoadCancelInprogressStartAction => {
    return {
        type: '@@logs/CANCEL_IN_PROGRESS_START',
        payload: {
            loading: true,
        },
    };
};
export const LoadCancelInprogressSuccess: ActionCreator<LoadCancelInprogressSuccessAction> = (): LoadCancelInprogressSuccessAction => {
    return {
        type: '@@logs/CANCEL_IN_PROGRESS_SUCCESS',
        payload: {
            loading: false,
        },
    };
};
export const LoadCancelInprogressError: ActionCreator<LoadCancelInprogressErrorAction> = (): LoadCancelInprogressErrorAction => {
    return {
        type: '@@logs/CANCEL_IN_PROGRESS_ERROR',
        payload: {
            loading: false,
        },
    };
};
export const ResendStart: ActionCreator<ResendStartAction> = (params: ResendParams): ResendStartAction => {
    return {
        type: '@@logs/RESEND_START',
        payload: {
            params,
        },
    };
};

export const ResendError: ActionCreator<ResendErrorAction> = (): ResendErrorAction => {
    return {
        type: '@@logs/RESEND_ERROR',
    };
};

export const ResendSuccess: ActionCreator<ResendSuccessAction> = (): ResendSuccessAction => {
    return {
        type: '@@logs/RESEND_SUCCESS',
    };
};

export const UpdateEventsCounts = (eventsCounts: Record<string, any>): UpdateEventsCountsSuccessAction => {
    return {
        type: LogsActionTypesEnum.UPDATE_EVENT_COUNTS,
        payload: eventsCounts,
    };
};

export const GetEventsCounts = (params: FetchEventsCountsPayload): FetchEventsCountsAction => {
    return {
        type: LogsActionTypesEnum.FETCH_EVENTS_COUNTS,
        payload: params,
    };
};

export const getLogsInProgressActivePage = (store: ApplicationState) => store.logs?.inProgressActivePage;
export const getLogsInprogressStatsPausedReason = (store: ApplicationState) => store.logs?.inprogressStatsDelayed?.PausedReason;

export const getLogInProgressDomainsLoading = (store: ApplicationState) => store.logs?.inProgressDelayedLoading;

export const getLogDomainsTotalCount = (store: ApplicationState) => store.logs.inprogressStatsDelayed?.Domains?.length || 0;

export const getLogsInProgressDomains = (store: ApplicationState) => store.logs?.inprogressStatsDelayed?.Domains;

export const getLogsStore = (store: ApplicationState): LogsState => store.logs;

export const getInProgressLoading = (store: ApplicationState) => store.logs.inProgressLoading;

export const getInProgressEmailsCount = (store: ApplicationState) => store.logs?.inprogressStatsDelayed?.Count || 0;
